<template>
  <div class="user-profile-widget">
    <template v-if="isAuthenticated">
      <user-status v-if="status" />
      <dropdown-menu>
        <template v-slot:activator>
          <user-auth-info />
        </template>

        <div class="dropdown-list">
          <!-- <app-btn block @click="openProfile">
            Профиль
          </app-btn> -->
          <app-btn block @click="logout">
            Выход
          </app-btn>
        </div>
      </dropdown-menu>
    </template>
    <div class="px-4 spacer" v-else>
      <app-btn
        block
        round
        icon
        color="orange-grad"
        @click="
          login();
          $app.metrics('signin');
        "
      >
        <SvgIcon size="20" name="steam-logo" />
        <span>Sign in</span>
      </app-btn>
    </div>
  </div>
</template>

<script>
import UserStatus from "./UserStatus";
import UserAuthInfo from "./UserAuthInfo";

import { mapGetters, mapActions } from "vuex";

export default {
  components: { UserStatus, UserAuthInfo },
  props: {
    status: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters("auth", ["user", "isAuthenticated", "isRegistred"])
  },

  methods: {
    ...mapActions("auth", ["login", "logout", "openProfile"])
  }
};
</script>

<style lang="scss">
.user-profile-widget {
  display: inline-flex;
  align-items: center;

  .menubar & {
    display: flex;
  }
}
</style>
